export default __webpack_public_path__ + "b75c434ed3205fd4abc98ca654be3126.jpg";